// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3akVe","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__1-6Gt","gfeWrapper":"CalendarEvent_gfeWrapper__RPCV0"};